// SCSS
import './main.scss';

// JS
import './components/google-reviews/google-reviews';
import './components/slick-slider/slick-slider';

jQuery(function ($) {
	//** Navigation functions **//

	// Check for taps to avoid accidental mouseenter firing
	var tap = ("ontouchstart" in document.documentElement);

	// Toggle the nav menu class which opens up the menu
	$('.sub-menu-toggle').on('click', function () {
		$(this).parent().toggleClass('active');
	});

	$('.menu-item-has-children').on('mouseenter', function () {
		if(!tap) {
			$(this).addClass('active');
		}
	});

	$('.menu-item-has-children').on('mouseleave', function () {
		$(this).removeClass('active');
	});

	// Mobile button toggle
	$('#primary-mobile-menu').on('click', function () {
		$(this).toggleClass('active');
		$('.menu-container').toggleClass('active');
	});

	//** Navigation ends **//

// Add header class for alternate styling on scroll
	$(window).scroll(function () {
		if ($(this).scrollTop() > 50) {
			$('#site-header').addClass('scrolled');
		} else {
			$('#site-header').removeClass('scrolled');
		}
	});

});

